import api from '../../../api/api'
import { DEFAULT_LIBRARY_ELEMENTS_LIMIT } from './Library.constants'
import { Content, SectionPage } from './Library.types'

export const getLibrary = async (searchPhrase?: string) => {
  const searchParam = typeof searchPhrase === 'string' && searchPhrase.length > 2 ? { $search: searchPhrase } : {}
  const limitParam = { limit: DEFAULT_LIBRARY_ELEMENTS_LIMIT }

  const { data } = await api.get<Content>('/library', {
    params: { ...searchParam, ...limitParam }
  })

  return data
}

export const getLibraryPage = async (sectionId: string, paginationOptions: { before: string } | { after: string }) => {
  const { data } = await api.get<SectionPage>(`/library/${sectionId}`, {
    params: { ...paginationOptions, limit: DEFAULT_LIBRARY_ELEMENTS_LIMIT }
  })

  return data
}

export const getStudyTime = (timezone: string) => api.post<{ timeSpent: number }>('/daily-lesson/time', { timezone })
